import {mapGetters} from "vuex";
export default {
    data() {
        return {
            list: [],
            loading: false
        }
    },
    computed: {
        ...mapGetters('async', [
            'customer_functions_hash',
            'account_leaf_titles_hash', 
            'analysis_titles_hash',
            'title_mappings_hash'
          ]),
    },
    created() {
       this.account_leaf_titles_hash
       this.analysis_titles_hash
       this.title_mappings_hash
    },
    methods: {
        showAnalysisTitle(id) {
            const analysis_titles_hash = this.analysis_titles_hash || {}
            const account = analysis_titles_hash[id] || {}
            return account.full_name
        },
        showAccountLeafTitle(id) {
            const account_leaf_titles_hash = this.account_leaf_titles_hash || {}
            const account = account_leaf_titles_hash[id] || {}
            return account.full_name
        },
        showCustomerFunctionName(id) {
            const customer_functions_hash = this.customer_functions_hash || {}
            const customer = customer_functions_hash[id] || {}
            return customer.name
          },
        getListProxy() {
            if (!this.Api) {
                return 
            }
            this.loading = true
            this.Api(this.params).then(res => {
                this.list = res
            }).finally(() => {
                this.loading = false
            })
        },
        getListFromParent() {
            if (this.list.length) {
                return 
            }
            this.getListProxy()
        }
    }
}   